import type { IconData } from '@stacksjs/iconify-core'

export const equalizer: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M96 146.025V16H64v130.025a64.009 64.009 0 0 0 0 123.95V496h32V269.975a64.009 64.009 0 0 0 0-123.95M80 240a32 32 0 1 1 32-32a32.036 32.036 0 0 1-32 32m192 50.025V16h-32v274.025a64.009 64.009 0 0 0 0 123.95V496h32v-82.025a64.009 64.009 0 0 0 0-123.95M256 384a32 32 0 1 1 32-32a32.036 32.036 0 0 1-32 32M448 82.025V16h-32v66.025a64.009 64.009 0 0 0 0 123.95V496h32V205.975a64.009 64.009 0 0 0 0-123.95M432 176a32 32 0 1 1 32-32a32.036 32.036 0 0 1-32 32\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default equalizer
